import moment from "moment/moment";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import useDebounse from "../../helpers/useDebounse";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";

import { useSelector } from "react-redux";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { PaginatedItems } from "../../components/pagination/Pagination";
import { filterSelectors, presenceSelectors, sortSelectors } from "./productSelectorsData";

const Products = () => {
    const [currentPage, setCurrentPage] = useState(1);

    const permissions = useSelector((state) => state.status.permissions);

    const [selectStoreList, setSelectStoreList] = useState([]);
    const [selectShippersList, setSelectShippersList] = useState([]);
    const [selectCategoriesList, setSelectselectCategoriesList] = useState([]);

    const [search, setSearch] = useState("");
    const [presence, setPresence] = useState(1);
    const [sort, setSort] = useState([...sortSelectors[0].value]);
    const [store, setStore] = useState([]);
    const [shipper, setShipper] = useState([]);
    const [category, setCategory] = useState([]);
    const [filter, setFilter] = useState([]);
    const [showOnlyDevices, setShowOnlyDevices] = useState("");
    const [productsList, setProductsList] = useState([]);

    const debounceSearch = useDebounse(search, 1000);

    const filterParams =
        filter.length > 0
            ? `&without_price_stock_usd=${+filter.includes("without_price_stock_usd")}&without_mpn=${+filter.includes(
                  "without_mpn",
              )}`
            : "";
    const orderParams = `&order=${sort[0]}&order_sort=${sort[1]}`;
    const searchParams = search.length > 0 ? `search=${debounceSearch}` : "";
    const storeParams = store.join("");
    const shipperParams = shipper.join("");
    const categoryParams = category.join("");
    const presenceParams = `&quantity=${presence}`;
    const pagination = "&page=" + currentPage;

    const combinedQwery =
        searchParams +
        orderParams +
        filterParams +
        storeParams +
        shipperParams +
        categoryParams +
        presenceParams +
        showOnlyDevices +
        pagination;

    const { data: products, refetch: refetchProducts } = useGetPageQuery(`products?per_page=40&` + combinedQwery);
    const { data: stores } = useGetPageQuery("stores?per_page=200&");
    const { data: shippers } = useGetPageQuery("shippers");
    const { data: selectCategories } = useGetPageQuery("categories/select");
    const [deleteUser, { isLoading, isError }] = useSendFormMutation();

    useEffect(() => {
        if (stores) {
            setSelectStoreList([
                ...stores.data.map((store) => {
                    return { value: store.id, label: store.title };
                }),
            ]);
        }
        if (shippers) {
            setSelectShippersList([
                ...shippers.data.map((shipper) => {
                    return { value: shipper.id, label: shipper.title_short };
                }),
            ]);
        }
        if (selectCategories) {
            setSelectselectCategoriesList([
                ...selectCategories.map((category) => {
                    return {
                        value: category.id,
                        label: "\u00A0\u00A0\u00A0\u00A0\u00A0".repeat(category.level) + category.title,
                    };
                }),
            ]);
        }
    }, [stores, shippers, selectCategories]);

    useEffect(() => {
        async function refetch() {
            refetchProducts();
        }
        refetch();
    }, []);

    const onPresenceSelectHandler = (selected) => {
        setPresence(selected.value);
    };

    const onSortSelectHandler = (selected) => {
        setSort(selected.value);
    };

    const onStoreSelectHandler = (selected) => {
        setStore([...selected.map((store) => `&store_ids[]=` + store.value)]);
    };

    const onShipperSelectHandler = (selected) => {
        setShipper([...selected.map((shipper) => "&shipper_ids[]=" + shipper.value)]);
    };

    const onCategorySelectHandler = (selected) => {
        setCategory([...selected.map((category) => "&category_ids[]=" + category.value)]);
    };

    const onFilterSelectHandler = (selected) => {
        setFilter([...selected.map((filter) => filter.value)]);
    };

    const showOnlyDevicesButttonHandler = (e) => {
        if (e.target.checked) {
            setShowOnlyDevices(
                "&category_ids[]=1&category_ids[]=13&category_ids[]=14&category_ids[]=16&category_ids[]=17&category_ids[]=18&category_ids[]=19",
            );
        } else {
            setShowOnlyDevices("");
        }
    };

    const deleteProductsHandler = async () => {
        for (const product of productsList) {
            await deleteUser({ body: {}, url: "products/" + product, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchProducts();
    };

    const checkAllHandler = () => {
        setProductsList(products.data.map((user) => user.id.toString()));
    };

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setProductsList([...productsList, e.target.value]);
        } else if (!e.target.checked) {
            setProductsList([...productsList.filter((id) => id !== e.target.value)]);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {products && stores && (
                <div className="content">
                    <div className="col-12">
                        <div className="page-header d-flex justify-content-between align-items-center mb-3">
                            <div className="header">
                                <h1>{products.total} товари</h1>
                            </div>
                            <div className="page-header__button">
                                <div className="float-right">
                                    <Link
                                        to={"/product"}
                                        className="add btn btn-primary"
                                    >
                                        Додати товар
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <a
                            className="check_all"
                            onClick={checkAllHandler}
                        >
                            Виділити все
                        </a>
                        <div className="row">
                            <div className="col-12 col-sm-12  col-md-12 col-lg-9 mobile-last">
                                <div id="list_form">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th data-field="check"></th>
                                                <th
                                                    data-field="id"
                                                    className="no-mobile"
                                                >
                                                    ID
                                                </th>
                                                <th data-field="user_name">Назва</th>
                                                <th
                                                    data-field="user_imei"
                                                    className="no-mobile"
                                                >
                                                    IMEI
                                                </th>
                                                <th data-field="user_address">Ціна</th>
                                                <th
                                                    data-field="user_phone"
                                                    className="no-mobile"
                                                ></th>

                                                <th
                                                    data-field="user_status"
                                                    className="no-mobile"
                                                >
                                                    Склад
                                                </th>
                                                <th
                                                    data-field="user_site"
                                                    className="no-mobile text-nowrap"
                                                >
                                                    Сайт
                                                </th>
                                                <th
                                                    data-field="user_date"
                                                    className="no-mobile"
                                                >
                                                    Створено
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {products.data.map((product) => {
                                                return (
                                                    <tr key={product.id}>
                                                        <td
                                                            className="check_area text-right"
                                                            key={product.id}
                                                        >
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={productsList.includes(
                                                                        product.id.toString(),
                                                                    )}
                                                                    value={product.id}
                                                                    onChange={(e) => listCheckHandler(e)}
                                                                />
                                                                <label className="custom-control-label">&nbsp;</label>
                                                            </div>
                                                        </td>
                                                        <td className="no-mobile fit">#{product.id}</td>
                                                        <td>
                                                            <Link
                                                                to={"/product/" + product.id}
                                                                data-id="133449"
                                                            >
                                                                {`${product.title} ${
                                                                    product?.imei_sn
                                                                        ? `(${product?.imei_sn.slice(-5)})`
                                                                        : ""
                                                                }`}
                                                            </Link>
                                                            {
                                                                <div>
                                                                    {product.a_model ? (
                                                                        <span className="badge bg-secondary">
                                                                            {product.a_model}
                                                                        </span>
                                                                    ) : null}
                                                                    {product.shipper ? (
                                                                        <span className="badge bg-danger">
                                                                            {product?.shipper?.title_short}
                                                                        </span>
                                                                    ) : null}
                                                                    {product.is_coming ? (
                                                                        <span className="badge bg-danger">
                                                                            Товар у дорозі
                                                                        </span>
                                                                    ) : null}
                                                                </div>
                                                            }
                                                            {product.status ? (
                                                                <div className="note note-status">{product.status}</div>
                                                            ) : null}
                                                            {product.store ? (
                                                                <div className="product_store">
                                                                    {product.store.title}
                                                                </div>
                                                            ) : null}
                                                        </td>
                                                        <td className="no-mobile">
                                                            {product.imei_sn}
                                                            {product?.is_exchange ? (
                                                                <>
                                                                    <br />
                                                                    <span className="badge bg-warning">з обміну</span>
                                                                </>
                                                            ) : null}
                                                        </td>
                                                        <td>
                                                            <div>${product.price_usd}</div>
                                                            <div className="on-mobile"></div>
                                                        </td>
                                                        {product.status_battery ? (
                                                            <td className="no-mobile fit">
                                                                <span className=" badge bg-success d-flex align-items-center">
                                                                    <i className="bi bi-battery-half me-1 fs-6"></i>
                                                                    {product.status_battery}%
                                                                </span>
                                                            </td>
                                                        ) : (
                                                            <td className="no-mobile fit"></td>
                                                        )}

                                                        <td className="no-mobile">{product.quantity}</td>
                                                        <td className="no-mobile fit ">
                                                            <span
                                                                className={`badge ${
                                                                    product.is_website ? "bg-success" : "bg-danger"
                                                                }  text-center `}
                                                            >
                                                                {product.is_website ? (
                                                                    <i class="bi bi-plus-lg"></i>
                                                                ) : (
                                                                    <i class="bi bi-dash"></i>
                                                                )}
                                                                {/* {product?.is_website ? "+" : "-"} */}
                                                            </span>
                                                        </td>
                                                        <td className="no-mobile">
                                                            {moment(product.created_at).format("DD.MM.YYYY")}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    {permissions.includes("product_edit") || permissions.includes("all") ? (
                                        <div className="d-flex mb-3">
                                            <select
                                                name="action"
                                                className="form-select"
                                                style={{ width: "auto" }}
                                            >
                                                <option value="delete">Видалити</option>{" "}
                                            </select>
                                            <button
                                                className="btn btn-info mx-3"
                                                onClick={deleteProductsHandler}
                                            >
                                                {isLoading ? "Завантаження" : "Виконати"}
                                            </button>
                                        </div>
                                    ) : null}

                                    <nav>
                                        <PaginatedItems
                                            pageCount={products.last_page}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    </nav>
                                </div>
                            </div>
                            <div className="col-12  col-lg-3 mobile-first">
                                <div
                                    className="pb-2 pt-4"
                                    id="top__filters"
                                >
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Пошук..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            id="button-addon2"
                                        >
                                            <i className="bi bi-search"></i>
                                        </button>
                                    </div>
                                    <div className="form-check form-switch mt-3">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            onChange={(e) => showOnlyDevicesButttonHandler(e)}
                                        />
                                        <label className="form-check-label">Відображати тільки пристрої</label>
                                    </div>
                                    <div className="mt-3">
                                        <label className="d-block">Наявність</label>
                                        <Select
                                            options={presenceSelectors}
                                            defaultValue={[presenceSelectors[0]]}
                                            onChange={onPresenceSelectHandler}
                                        />
                                    </div>
                                    <div className="mt-3">
                                        <label className="d-block">Сортування</label>
                                        <Select
                                            options={sortSelectors}
                                            defaultValue={[sortSelectors[0]]}
                                            onChange={onSortSelectHandler}
                                        />
                                    </div>
                                    <div className="mt-3">
                                        <label className="d-block">Магазини</label>
                                        <Select
                                            options={selectStoreList}
                                            placeholder={"Магазини"}
                                            isMulti
                                            onChange={onStoreSelectHandler}
                                        />
                                    </div>
                                    <div className="mt-3">
                                        <label className="d-block">Постачальник</label>
                                        <Select
                                            options={selectShippersList}
                                            placeholder={"Постачальник"}
                                            isMulti
                                            onChange={onShipperSelectHandler}
                                        />
                                    </div>
                                    <div className="mt-3">
                                        <label className="d-block">Категорія</label>
                                        <Select
                                            options={selectCategoriesList}
                                            placeholder={"Категорія"}
                                            isMulti
                                            onChange={onCategorySelectHandler}
                                        />
                                    </div>
                                    <div className="mt-3">
                                        <label className="d-block">Фільтр</label>
                                        <Select
                                            options={filterSelectors}
                                            placeholder={"Фільтр"}
                                            isMulti
                                            onChange={onFilterSelectHandler}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Products;
